<template>
  <div>
    <img class="vendor__logo" :src="vendor.logo" />
    <div class="vendor__title title-employee">
      {{vendor.company_name}}
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'
export default {
  name: 'SidebarVendor',
  computed: {
    ...mapState({
      vendor: state => state.employeeVendor.vendor
    })
  },
  mounted () {
    this.$store.dispatch('employeeVendor/getVendor')
  }
}
</script>
<style scoped lang="scss">
  @import "@/assets/stylesheet/vendor/detail_vendor.scss";
</style>



// WEBPACK FOOTER //
// src/views/Employee/Company/Sidebar.vue